import makeItemsReducer from './items'
import { removeItem, normalizeItem } from './items/utils'
import { isUndefined, isNull } from 'lodash'
import {
  GET_OWNED_ITEMS,
  SET_ITEM_NOT_OWNED_SUCCESS,
  OWNED_ITEM_UPDATED,
} from '../actions'

const handleOwned = (prevState, { type, payload }) => {
  // When no data in list don't care
  if (prevState && isNull(prevState.ids)) {
    return prevState
  }

  switch (type) {
    case SET_ITEM_NOT_OWNED_SUCCESS:
      return removeItem(prevState, payload.itemId)
    case OWNED_ITEM_UPDATED:
      if (isUndefined(prevState.data[payload.id])) {
        return {
          ...prevState,
          ids: [payload.id].concat(prevState.ids),
          data: {
            ...prevState.data,
            [payload.id]: normalizeItem(payload),
          },
        }
      }
      return prevState
    default:
      return prevState
  }
}

export default makeItemsReducer(GET_OWNED_ITEMS, {
  handleWanted: false,
  extendReducers: [handleOwned],
})



// WEBPACK FOOTER //
// ./src/reducers/ownedItems.js